import { render, staticRenderFns } from "./statement_Kbank.vue?vue&type=template&id=04e8ee61&scoped=true&"
import script from "./statement_Kbank.vue?vue&type=script&lang=js&"
export * from "./statement_Kbank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e8ee61",
  null
  
)

export default component.exports